import axios, { AxiosResponse } from 'axios';
import * as utils from './apiUtils';
import { CleaningMasterGetAllResponse } from '@/models/apis/cleaning/cleaningCommon';

export default {
  getAll(): Promise<AxiosResponse<CleaningMasterGetAllResponse>> {
    return axios.get(utils.getApiUrl('/cleaning_masters'));
  },
};
